(function() {
  'use strict';

  function debounce(fn, delay) {
    var timerId;
    return function() {
      clearTimeout(timerId);
      timerId = setTimeout(fn, delay);
    };
  }

  function loadStyle(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function(resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    var existing = document.querySelector('script[src="' + src + '"]');
    if (existing) {
      if (existing.dataset.loaded === 'true') return Promise.resolve();
      return new Promise(function(resolve) {
        existing.addEventListener('load', resolve, { once: true });
      });
    }

    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function() {
        script.dataset.loaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function scheduleIdle(fn, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(fn, { timeout: timeout || 2500 });
      return;
    }

    window.setTimeout(fn, timeout || 1500);
  }

  var PREV_ARROW_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 18l-6-6 6-6"></path></svg>';
  var NEXT_ARROW_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6l6 6-6 6"></path></svg>';

  function initSlickSliders() {
    if (!document.querySelector('.reviews-grid, .review_group-collection, .how-we-help-carousel')) return;

    function initSlick() {
      var $ = window.jQuery;
      if (!$ || !$.fn || !$.fn.slick) return;

      var $reviewsGrid = $('.reviews-grid');
      var $groupCollection = $('.review_group-collection');
      var $howWeHelp = $('.how-we-help-carousel');

      var updateReviewsSlider = function() {
        if (!$reviewsGrid.length) return;

        var isInitialized = $reviewsGrid.hasClass('slick-initialized');
        var shouldUseSlider = window.innerWidth <= 1024;

        if (shouldUseSlider) {
          if (!isInitialized) {
            $reviewsGrid.slick({
              dots: false,
              arrows: true,
              infinite: false,
              speed: 400,
              slidesToShow: 2,
              slidesToScroll: 2,
              centerMode: false,
              adaptiveHeight: false,
              prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' + PREV_ARROW_SVG + '</button>',
              nextArrow: '<button type="button" class="slick-next" aria-label="Next">' + NEXT_ARROW_SVG + '</button>',
              responsive: [
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]
            });
          }
        } else if (isInitialized) {
          $reviewsGrid.slick('unslick');
        }
      };

      var updateCollectionSlider = function() {
        if (!$groupCollection.length) return;
        var isInitialized = $groupCollection.hasClass('slick-initialized');

        if (window.innerWidth <= 1300) {
          if (!isInitialized) {
            $groupCollection.slick({
              dots: true,
              arrows: false,
              infinite: false,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              centerPadding: '20px'
            });
          }
        } else if (isInitialized) {
          $groupCollection.slick('unslick');
        }
      };

      var updateHowWeHelpSliders = function() {
        if (!$howWeHelp.length) return;

        $howWeHelp.each(function() {
          var $carousel = $(this);
          var isInitialized = $carousel.hasClass('slick-initialized');

          if (window.innerWidth <= 1024) {
            if (!isInitialized) {
              $carousel.slick({
                dots: true,
                arrows: true,
                infinite: false,
                speed: 400,
                slidesToShow: 2,
                slidesToScroll: 1,
                adaptiveHeight: true,
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous">' + PREV_ARROW_SVG + '</button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next">' + NEXT_ARROW_SVG + '</button>',
                responsive: [
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 1
                    }
                  }
                ]
              });
            }
          } else if (isInitialized) {
            $carousel.slick('unslick');
          }
        });
      };

      var handleResize = debounce(function() {
        updateReviewsSlider();
        updateCollectionSlider();
        updateHowWeHelpSliders();
      }, 200);

      updateReviewsSlider();
      updateCollectionSlider();
      updateHowWeHelpSliders();
      window.addEventListener('resize', handleResize);
    }

    var jquerySrc = 'https://cdn.jsdelivr.net/npm/jquery@3.6.0/dist/jquery.min.js';
    var slickJsSrc = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
    var slickCssSrc = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css';
    var slickThemeCssSrc = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css';
    var jqueryPromise = window.jQuery ? Promise.resolve() : loadScript(jquerySrc);

    jqueryPromise
      .then(function() {
        return Promise.all([
          loadStyle(slickCssSrc),
          loadStyle(slickThemeCssSrc),
          window.jQuery && window.jQuery.fn && window.jQuery.fn.slick ? Promise.resolve() : loadScript(slickJsSrc)
        ]);
      })
      .then(initSlick)
      .catch(function() {});
  }

  function disableMobileAffiliateFlickity() {
    if (window.innerWidth > 640) return;

    var sections = document.querySelectorAll('.affiliate_image-text .text-with-icons.flickity-enabled');
    sections.forEach(function(section) {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        var flickityInstance = window.Flickity.data(section);
        if (flickityInstance) {
          flickityInstance.destroy();
        }
      }

      section.classList.remove('flickity-enabled', 'is-draggable');
      section.removeAttribute('tabindex');

      var viewport = section.querySelector('.flickity-viewport');
      var slider = section.querySelector('.flickity-slider');
      if (viewport && slider) {
        section.innerHTML = slider.innerHTML;
      }

      section.querySelectorAll('.text-with-icons__item').forEach(function(item) {
        item.removeAttribute('style');
        item.classList.remove('is-selected');
      });
    });
  }

  function initDeferredThirdParties() {
    if (window.sparkOptions) {
      scheduleIdle(function() {
        loadScript('https://sparkcdn.io/sparkjs/filterflair/live').catch(function() {});
      }, 1200);
    }
  }

  function init() {
    initSlickSliders();
    disableMobileAffiliateFlickity();
    initDeferredThirdParties();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
